import { createApiService } from "./apiServiceFactory";
import type { institution } from "@/features/userManagement/components/userFormModal/types.props";
import type { institutionFilters } from "@/types/filters/filters.domain";

export const institutionService = createApiService<
    institution,
    institutionFilters,
    { name: string }
>("institutions");
